import i18n from '@/libs/i18n'

export default [
  // *===============================================---*
  // *--------- COUNSELING ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/counselings/list',
    name: 'pages-counseling-list',
    component: () => import('@/views/pages/counseling/CounselingList.vue'),
    meta: {
      resource: 'counseling',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.counselings'),
          active: false,
        },
      ],
      pageTitle: i18n.t('counselings.mainVerticalMenu.counselingsList'),
    },
  },
  {
    path: '/counselings/empty',
    name: 'pages-counseling-empty',
    component: () => import('@/views/pages/counseling/EmptyCounselings.vue'),
    meta: {
      resource: 'counseling',
      action: 'read',
      breadcrumb: [
        {
          text: i18n.t('general.emptyCounselings'),
          active: false,
        },
      ],
      pageTitle: i18n.t('counselings.mainVerticalMenu.emptyCounselings'),
    },
  },
  {
    path: '/counselings/no-response',
    name: 'pages-counseling-no-response',
    component: () => import('@/views/pages/counseling/NoResponseCounselingList.vue'),
    meta: {
      resource: 'counseling',
      action: 'report',
      breadcrumb: [
        {
          text: i18n.t('general.noResponseCounselings'),
          active: false,
        },
      ],
      pageTitle: i18n.t('counselings.mainVerticalMenu.noResponseCounselings'),
    },
  },
  {
    path: '/counselings/edit/:id',
    name: 'pages-counseling-edit',
    component: () => import('@/views/pages/counseling/CounselingEdit.vue'),
    meta: {
      resource: 'counseling',
      action: 'update',
      breadcrumb: [
        {
          text: i18n.t('general.counseling'),
          active: false,
        },
      ],
      pageTitle: i18n.t('counselings.mainVerticalMenu.counselings'),
    },
  },
  {
    path: '/counselings/messages/:id',
    name: 'pages-counseling-messages',
    component: () => import('@/views/pages/counseling/CounselingMessages.vue'),
    meta: {
      resource: 'counseling',
      action: 'create',
      breadcrumb: [
        {
          text: i18n.t('general.counseling'),
          active: false,
        },
      ],
      pageTitle: i18n.t('counselings.mainVerticalMenu.counselings'),
    },
  },
  {
    path: '/counselings/transfer',
    name: 'pages-counseling-transfer',
    component: () => import('@/views/pages/counseling/CounselingTransfer.vue'),
    meta: {
      resource: 'counseling',
      action: 'transfer',
      breadcrumb: [
        {
          text: i18n.t('general.counseling'),
          active: false,
        },
      ],
      pageTitle: i18n.t('counselings.transferCounseling'),
    },
  },

]
